var _style, _g, _g2, _path, _path2, _path3, _polyline, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNodeBody = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "NodeBody",
  x: "0px",
  y: "0px",
  viewBox: "0 0 320 360.9",
  style: {
    enableBackground: "new 0 0 320 360.9"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10.0001;}\r\n\t.st2{fill:none;stroke:#071F33;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#071F33;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#071F33;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st5{fill:#071F33;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#071F33;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#50AD70;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M76.3,132.5l-38.9-10.4c0,0-7.5,38.9-2,59l41-4.2C76.3,176.8,72.1,160.1,76.3,132.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M54.9,196.1c0,0,6.4,23.5,16,38.9l-27.1,19.3c0,0-14.6-20.5-22.1-50.6L54.9,196.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M143.2,21.2c-7.8,2.5-15.8,5.7-24.1,9.7c-0.2,0-58.3,36.4-68.8,83.6l-10-3.4c0,0,15.9-55.6,74.9-87.8 c0,0,1.6-1,4.7-2.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M143.2,21.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320,90.4c-11.2-21.4-29.7-43.5-59.9-59.5c0,0-7.5-4.8-20.6-9.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320,90.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320.1,74.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M259.1,20.3c2,1,3.9,2,5.9,3c0,0,31.2,16,55.1,51.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M259.1,20.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M120,20.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "93.1,122.1 60,109.9 64.6,99.5 95.2,114.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "68.8,92 74.7,82.1 103.6,103.2 99.8,110.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "107.7,96.3 112.3,91.6 86.1,66.9 79.7,75.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.1,86.5 122.3,81.7 99.4,54.3 91.4,62.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "128.2,77.7 134.5,73.1 114.8,43 106.8,48.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "122.3,38.8 131.9,34.2 146.2,66.9 139.5,70.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "138.7,30.9 149.6,26.3 160.4,60.3 152.8,64.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "166.3,60.3 174.6,58.2 168.3,22.9 157.5,26.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "174.6,21.3 186.3,21.3 186.3,56.4 180.5,56.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "193.6,21.3 204.8,21.3 202.2,56.4 193.6,56.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "213.5,22.9 225.7,26.3 215.6,60.3 208.1,56.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "221.5,60.3 229.4,64.3 242.4,32.6 231.9,26.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "234,66.9 240.7,70.4 259.1,41.7 249,34.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "246.6,73.1 252.8,77.7 275.8,52.3 266.7,43  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "259.1,81.7 264.5,86.5 290,64.3 281.3,56.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "269.1,92 274.6,99.5 304.3,77.7 295.5,66.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "307.2,83.2 312.3,92.8 282.1,110.7 275.8,103.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "284.2,115.3 286.7,123.3 319.7,110.7 316.4,101.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M319.9,118.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M319.7,130"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "319.9,118.2 290,127.9 290,135.4 319.7,130  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "319.7,148.2 294,149.7 292.2,142.6 319.7,136.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M319.7,148.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M319.7,136.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M52.5,266.8l25.1-19.7c0,0,31.3,31.8,48,39.3l-15.9,29.3C109.8,315.7,68.1,290.6,52.5,266.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M138.7,292.7l32.2,8.4l-4.1,30.9c0,0-21.8,2.1-36.9-8.8L138.7,292.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M319.7,159.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320,201.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M319.7,159.6h-12.6c0,0,5.2,64.4-60.4,102.9c0,0-34.9,29.7-107.9,3c-0.1,0-37.4-10-62.5-76.9L57.9,194 c0,0,10.9,60.6,74.1,89.9c0,0,58.1,31.4,124.7-2.6c0,0,45.4-23.4,63.3-80"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M83.9,135.4l19.7,5c0,0-15.9,60.2,38.5,95.4l-9.2,18.4C132.8,254.3,70.4,223.7,83.9,135.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M146.2,260.9l7.5-18.4c0,0,48.6,17.5,82.4-6.2c0,0,39.7-24.3,42.6-74.5h19.7c0,0,4.6,50.2-47.2,89.1 C251.2,250.9,215.6,284.8,146.2,260.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M106.8,128.8l-7.5-2.3c0,0,6.6-28.4,46.2-52.9c0.4-0.2,0.8-0.5,1.2-0.7c5.8-3.1,48.5-23.8,95.6,5 c0,0,42.6,29.7,44.4,73.9h-8.4c0,0-3.4-45-40.2-65.1c0,0-41.6-28.5-88.6-4.9C149.6,81.7,114.9,99.5,106.8,128.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M188.4,302.3c0,0,58.1,3.4,95.8-32.8L294,280c0,0-47.4,42.8-105.6,37V302.3L188.4,302.3z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 190,
  cy: 161.1,
  r: 79.5
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st1",
  cx: 190,
  cy: 161.3,
  rx: 45,
  ry: 45
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M208.6,217.8l6,19.9c0,0,19.1-7.3,26.3-15.2l-13.1-16.7C228,205.7,221.8,212.1,208.6,217.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M242.3,209.9c0,0,8.5-9.2,12.6-17.6l15.8,6.6c0,0-5,12-16,23.6L242.3,209.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M207.8,234.1l1.3,5.3c0,0-28.7,8.3-58.9-8.7c0,0-37.8-19-40.9-65.4c0,0-4-46.1,37.1-73l2.7,4.2 c0,0-38.6,22.1-35.1,69c0,0-0.3,37.3,38.6,61.5C152.6,227,184.3,242.4,207.8,234.1z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "199.4,213.4 203.2,231.1 197.4,232 195.7,214.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "192.9,232.2 187,232.3 188.4,214 192.7,213.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "184.2,214.1 180.9,213.4 177.2,231.5 182.8,231.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "177.7,213 173.8,211.6 168.1,229.2 173.8,230.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "170.5,210.2 166.8,208.7 159.1,225.5 163.5,227.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "155.2,223.3 150.5,220.4 160.9,205.3 164.3,207.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "147.2,218.5 142.2,214.9 154.2,200.8 157.9,203  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "152.5,198.3 149.4,195.3 135.6,207.6 140.1,211.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "133.2,205.4 130,200.2 145.3,190.6 146.9,193.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "127.9,197 125,192.1 141,183.7 143.3,187.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "123.2,187.8 121.4,181.7 139.1,176.7 139.4,181.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "137.4,174.2 137,169.6 119.6,172.6 119.7,179  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "136.8,166.9 136.6,163.1 119,162.9 118.5,169.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "136.1,159.7 136.4,155.7 119.1,152.7 117.5,159.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "136.4,151.9 137.1,148.3 120.4,143.2 119.4,149.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "138.2,144.7 140,140.3 122.4,133.3 120,140.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "124,130.5 126.8,125.7 142.8,133.9 141.5,138.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "144.3,131.7 147.1,128.5 132.5,117.5 129.4,121.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "135,114.7 148.1,125.7 151.5,123.7 139.5,110.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "141.5,107.8 146.1,103.4 156.6,118.1 154.1,120.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M273.8,191.5l-15.4-5.6c0,0,5.3-22.3,4-31.7l17.1-1C279.5,153.2,279.9,178.3,273.8,191.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M261.6,146.8l-5.1-16.3l14.6-6.6c0,0,6.9,9,6.2,18.6L261.6,146.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M233.1,202.5l7.4,6.5c0,0,23.5-21.3,19.1-56.9c0,0-2.2-34-35.2-53.8c0,0-33.6-19.9-72.3,2.6l5.4,8.7 c0,0,26.7-19.9,61.4-1.7c0,0,22.5,7.1,30.8,46.3C249.6,154.3,255.4,173.3,233.1,202.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M207.8,213.8l-3.2-10c0,0,30.6-9.5,31.1-42.8l10.5-1C246.4,159.9,250,195.5,207.8,213.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M245.6,152.2l-10.1,1.7c0,0-5.6-26-25.3-34.3c0,0-21.4-10.7-44.2,1.7l-5.4-8.6c0,0,20.7-15.7,51.8-3.7 C212.5,109.1,237.1,115.4,245.6,152.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M198.6,205.5l1,3.9c0,0-14.2,4.9-35.8-5.7c-0.2-0.1-0.4-0.2-0.6-0.3c-3-1.7-23.7-14.7-24-43 c0,0,1.3-26.7,20.1-39.6l2.2,3.7c0,0-18.8,13.8-17.4,35.3c0,0-1,26,22.1,40.1C166.4,199.8,183.6,210.1,198.6,205.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M252.2,122.5c0,0-14.4-26.3-40.5-32.8l1.9-7.1c0,0,31.7,9,45,36L252.2,122.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 190.1,
  cy: 160.4,
  r: 40.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 190.2,
  cy: 160.3,
  r: 23.2
})), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 190.1,
  cy: 161.3,
  r: 89.4
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 243.4,
  y1: 45.3,
  x2: 243.4,
  y2: 23
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 237.1,
  y1: 45.3,
  x2: 237.1,
  y2: 23
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M228.8,23v18.3c0,0,0.2,4.4,5.4,4.4h86.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M269.9,46v37.4c0,0,70.7,71.8,0,155.5v100.2v10.3c0,0,0,4.5,3.7,4.4H320"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M269.9,343.5h-63.5c-4.2,0-7.5-3.2-7.5-7v-40c0-3.9,3.3-7,7.5-7h63.5c4.2,0,7.5,3.2,7.5,7v40 C277.2,340.3,274,343.5,269.9,343.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M239.5,22.9h32.6c-1.4-19.5-9.3-21.4-9.3-21.4h-72.9H117c0,0-7.9,2.1-9.3,21.4h82.2H239.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M239.6,20.3h30.3c-2.5-17.5-7.2-17.5-7.2-17.5h-72.2h-72.3c0,0-5.8-1-8.2,17.5h80.5H239.6"
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "st8",
  points: "289.6,42.3 294.6,47.3 299.5,42.3 "
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 266,
  y1: 307.4,
  x2: 182.8,
  y2: 307.4
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 179.9,
  cy: 307.1,
  r: 2.9
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNodeBody, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NodeBody.04a765ca.svg";
export { ForwardRef as ReactComponent };